<template>
  <div v-if="displayRows.length" class="mb-3 mt-1">
    <div
      v-for="(row, idx) in displayRows"
      :key="rowKeyPrefix + '-' + idx"
      class="white--text body-2"
    >
      <span class="font-weight-medium">{{ moduleLabel(row.module) }}</span>:
      {{ displayStatus(row.status) }}<span v-if="hasTarget(row)"> — target {{ row.target_version }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DeviceUpdateStateRows',
    props: {
      rows: {
        type: Array,
        default: function () {
          return []
        },
      },
      rowKeyPrefix: {
        type: String,
        default: 'usr',
      },
    },
    computed: {
      displayRows() {
        return Array.isArray(this.rows) ? this.rows : []
      },
    },
    methods: {
      moduleLabel(module) {
        if (module == null || module === '') {
          return ''
        }
        return this.$helpers.titleCase(String(module))
      },
      displayStatus(status) {
        var s = this.$helpers.normalizeUpdateStateStatus(status)
        if (s === 'up to date' || s === 'already on newest version' || s === 'already on newer version') {
          return 'Up to date'
        }
        return status
      },
      hasTarget(row) {
        if (!row || row.target_version == null || row.target_version === '') {
          return false
        }
        var s = this.$helpers.normalizeUpdateStateStatus(row.status)
        return !(s === 'up to date' || s === 'already on newest version' || s === 'already on newer version')
      },
    },
  }
</script>
